import { useState } from 'react';

export interface TextQuery {
  readonly query: string;
  readonly setQuery: (value: string) => void;
}

/** A single filter-text field's state, kept out of the presentational list it narrows. */
export function useTextQuery(): TextQuery {
  const [query, setQuery] = useState('');
  return { query, setQuery };
}
